<template>
    <v-container>
      <div class="mb-5">
        <material-card color="primary" title="Tambah Pengguna" class="card-wrapper">
          <v-form>
            <v-row>
              <div class="form-input mt-5 mb-3">
                <p style="color: red">* Wajib Diisi</p>
              </div>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <p class="label font-weight-bold mb-1">Sumber<span style="color: red">*</span></p>
                    <v-radio-group
                    v-model="formData.sumber"
                    row
                    :error-messages="sumberErrors"
                    >
                        <v-radio
                            label="Internal"
                            value="Internal"
                        ></v-radio>
                        <v-radio
                            label="Eksternal"
                            value="Eksternal"
                        ></v-radio>
                    </v-radio-group>
                </v-col>

              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Username<span style="color: red">*</span></p>
                  <v-text-field 
                    dense
                    placeholder="Username" 
                    required
                    outlined
                    v-model="formData.username"
                    @input="$v.formData.username.$touch()"
                    @blur="$v.formData.username.$touch()"
                    :error-messages="usernameErrors"
                  />
                </div>
                <p v-if="errorMessageUserName" style="color:red;">{{errorMessage}}</p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama Lengkap<span style="color: red">*</span></p>
                  <v-text-field 
                    dense
                    placeholder="Nama Lengkap"
                    required
                    outlined
                    v-model="formData.nama_lengkap"
                    @input="$v.formData.nama_lengkap.$touch()"
                    @blur="$v.formData.nama_lengkap.$touch()"
                    :error-messages="namalengkapErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">NIK</p>
                  <v-text-field 
                    dense
                    placeholder="NIK" 
                    outlined
                    v-model="formData.nik"
                    @input="$v.formData.nik.$touch()"
                    @blur="$v.formData.nik.$touch()"
                    :error-messages="nikErrors"
                  />
                </div>
                <p v-if="errorMessageNik" style="color:red;">{{errorMessage}}</p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Jabatan</p>
                  <v-text-field 
                    dense
                    placeholder="Jabatan"
                    outlined
                    v-model="formData.jabatan"
                    @input="$v.formData.jabatan.$touch()"
                    @blur="$v.formData.jabatan.$touch()"
                    :error-messages="jabatanErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Email<span style="color: red">*</span></p>
                  <v-text-field 
                    dense
                    placeholder="Email" 
                    required
                    outlined
                    v-model="formData.email"
                    @input="$v.formData.email.$touch()"
                    @blur="$v.formData.email.$touch()"
                    :error-messages="emailErrors"
                  />
                </div>
                <p v-if="errorMessageEmail" style="color:red;">{{errorMessage}}</p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Organisasi (PAU/Fakultas/Sekolah)<span style="color: red">*</span></p>
                  <v-autocomplete
                    no-data-text="Tidak ada data"
                    :items="organisasis"
                    :item-text="item => item.nama"
                    :item-value="item => item.id"
                    dense
                    placeholder="Pilih Organisasi (PAU/Fakultas/Sekolah)"
                    clearable
                    required
                    outlined
                    v-model="formData.organisasi"
                    @input="$v.formData.organisasi.$touch()"
                    @blur="$v.formData.organisasi.$touch()"
                    :error-messages="organisasiErrors"
                    @keydown.enter.prevent
                    >
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">File Tanda Tangan</p>
                  <v-file-input
                    dense
                    v-model="formData.file_ttd"
                    outlined
                    accept=".png"
                    @input="$v.formData.file_ttd.$touch()"
                    @blur="$v.formData.file_ttd.$touch()"
                    hint="File harus berformat PNG"
                    persistent-hint=true
                    :error-messages="file_ttdErrors"
                  >
                  </v-file-input>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">File Paraf</p>
                  <v-file-input
                    dense
                    v-model="formData.file_paraf"
                    outlined
                    accept=".png"
                    @input="$v.formData.file_paraf.$touch()"
                    @blur="$v.formData.file_paraf.$touch()"
                    hint="File harus berformat PNG"
                    persistent-hint=true
                    :error-messages="file_parafErrors"
                  >
                  </v-file-input>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Peran Pengguna<span style="color: red">*</span></p>
                  <v-select
                    :items="allperans"
                    :item-text="item => item.nama"
                    :item-value="item => item.id"
                    dense
                    placeholder="Pilih Peran"
                    clearable
                    required
                    outlined
                    v-model="formData.defaultPeran"
                    @input="$v.formData.defaultPeran.$touch()"
                    @blur="$v.formData.defaultPeran.$touch()"
                    :error-messages="defaultPeranErrors"
                    @keydown.enter.prevent
                    >
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp;
                <v-btn color="primary" dark @click="postData()">Simpan</v-btn>&nbsp;
              </v-col>
            </v-row>
          </v-form>
        </material-card>
      </div>

    </v-container>
  </template>
  
<script>
  import { apiServer } from "../../setup-axios";
  import { minLength, maxLength, helpers, required } from "vuelidate/lib/validators";

  const usernameregex = helpers.regex('usernameregex', /^[a-zA-Z0-9._-]{1,255}$/i);
  const textregex = helpers.regex('textregex', /^[a-zA-Z0-9 .,'()&\/-]{1,255}$/i);
  const emailregex = helpers.regex('emailregex', /^[a-zA-Z0-9._]{2,220}@[a-zA-Z0-9.]{2,25}\.[a-zA-Z]{2,10}$/i);
  const nikregex = helpers.regex('nikregex', /^[0-9]{16}$|^$/i);

  export default {
    data: () => ({
      organisasis: [],
      allperans: [],
      successCreate: null,
      errorMessage:"",
      errorMessageUserName: false,
      errorMessageEmail: false,
      errorMessageNik: false,
      filettd: null,
      fileparaf: null,
      formData: {
        nama_lengkap:"",
        username:"",
        file_ttd:"",
        file_paraf:"",
        jabatan:"",
        nik:"",
        email:"",
        status: true,
        organisasi:"",
        sumber:"",
        defaultPeran:"",
      },

    }),
    validations: {
      formData: {
        nama_lengkap: {
          required,
          textregex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        username: {
          required,
          usernameregex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        email: {
          required,
          emailregex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        organisasi: {
          required,
          textregex,
        },
        nik: {
          nikregex
        },
        jabatan: {
          textregex
        },
        sumber: {
          required
        },
        defaultPeran: {
          required
        }
      }
    },
    computed: {
      filteredOrganisasi(){
          return this.organisasis.filter(item => item.status)
      },
      namalengkapErrors() {
        const errors = [];
        if (!this.$v.formData.nama_lengkap.$dirty) return errors;
        !this.$v.formData.nama_lengkap.required &&
        errors.push("Nama Lengkap harus diisi");
        !this.$v.formData.nama_lengkap.minLength &&
        errors.push("Nama Lengkap minimal 3 karakter");
        !this.$v.formData.nama_lengkap.maxLength &&
        errors.push("Nama Lengkap maksimal 255 karakter");
        !this.$v.formData.nama_lengkap.textregex &&
        errors.push("Nama Lengkap hanya boleh mengandung huruf, angka, spasi, dan tanda . , ' ( ) & / -");
        
        return errors;
      },
      usernameErrors() {
        const errors = [];
        if (!this.$v.formData.username.$dirty) return errors;
        !this.$v.formData.username.required &&
        errors.push("Username harus diisi");
        !this.$v.formData.username.minLength &&
        errors.push("Username minimal 3 karakter");
        !this.$v.formData.username.maxLength &&
        errors.push("Username maksimal 255 karakter");
        !this.$v.formData.username.usernameregex &&
        errors.push("Username hanya boleh mengandung huruf, angka, dan karakter '._-'");
        
        return errors;
      },
      emailErrors() {
        const errors = [];
        if (!this.$v.formData.email.$dirty) return errors;
        !this.$v.formData.email.required &&
        errors.push("Email harus diisi");
        !this.$v.formData.email.maxLength &&
        errors.push("Email maksimal 255 karakter");
        !this.$v.formData.email.emailregex &&
        errors.push("Format Email belum sesuai. Contoh: pusilkom@pusilkom.com");
        
        return errors;
      },
      nikErrors() {
        const errors = [];
        if (!this.$v.formData.nik.$dirty) return errors;
        !this.$v.formData.nik.nikregex &&
        errors.push("Nik hanya boleh mengandung angka sebanyak 16 digit");
        
        return errors;
      },
      organisasiErrors() {
        const errors = [];
        if (!this.$v.formData.organisasi.$dirty) return errors;
        !this.$v.formData.organisasi.required &&
        errors.push("Organisasi Pengguna harus dipilih");
        
        return errors;
      },
      jabatanErrors() {
        const errors = [];
        if (!this.$v.formData.jabatan.$dirty) return errors;
        !this.$v.formData.jabatan.textregex &&
        errors.push("Jabatan hanya boleh mengandung huruf, angka, spasi, dan tanda . , ' ( ) & / -");
        
        return errors;
      },
      sumberErrors() {
        const errors = [];
        if (!this.$v.formData.sumber.$dirty) return errors;
        !this.$v.formData.sumber.required &&
        errors.push("Sumber Pengguna harus dipilih");
        
        return errors;
      },
      defaultPeranErrors() {
        const errors = [];
        if (!this.$v.formData.defaultPeran.$dirty) return errors;
        !this.$v.formData.defaultPeran.required &&
        errors.push("Peran Pengguna harus dipilih");
        
        return errors;
      },
    },
    created() {
      console.log("loading organisasi");
      this.getOrganisasi();
      this.getListPeran();
    },
    methods: {
      postData() {
        this.$v.$touch()
        if (this.$v.$anyError) {
          return
        }
        this.errorMessageUserName = false
        this.errorMessageEmail = false
        this.errorMessageNik = false
        let createData = new FormData()
        createData.append("NamaLengkap",this.formData.nama_lengkap.trim(" "))
        createData.append("Username",this.formData.username.trim(" "))
        createData.append("Jabatan",this.formData.jabatan.trim(" "))
        createData.append("Nik",this.formData.nik)
        createData.append("Email",this.formData.email.trim(" "))
        createData.append("IdOrganisasi",this.formData.organisasi)
        createData.append("Sumber",this.formData.sumber.trim(" "))
        createData.append("Status",true)
        createData.append("DefaultPeran",this.formData.defaultPeran)
        if(this.formData.file_ttd != "") {
          createData.append("FileTtd","filettd")
          createData.append("file1",this.formData.file_ttd)
        }
        if(this.formData.file_paraf != "") {
          createData.append("FileParaf","fileparaf")
          createData.append("file2",this.formData.file_paraf)
        }
        console.log("create pengguna")
        console.log(createData)
        apiServer
            .post("/pengguna/create",createData)
            .then(response => {
              console.log("Successfully created pengguna:")
              console.log(response.data.data)
              localStorage.setItem('createSuccess', "Pengguna " + this.formData.username + " berhasil dibuat.")
              this.$router.push("/pengguna")})
            .catch(error => {
              console.log("There was an error:", error.response); // Logs out the error
              if (error.response.data.message.includes("Username")) {
                this.errorMessage = error.response.data.message
                this.errorMessageUserName = true
              } else if (error.response.data.message.includes("Email")) {
                this.errorMessage = error.response.data.message
                this.errorMessageEmail = true
              } else if (error.response.data.message.includes("NIK")) {
                this.errorMessage = error.response.data.message
                this.errorMessageNik = true
              } else {
                console.log(error.response)
                this.errorMessage = "Kesalahan pada Server. Silakan hubungi Administrator"
                this.errorMessageUserName = true
              }
            });
      },
      getOrganisasi() {
        this.isLoading = true;
        apiServer
            .get("/organisasi/all")
            .then(response => {
              this.organisasis = response.data.data;
              console.log("search organisasi loaded")
              console.log(this.organisasis)
            })
            .catch(error => {
              console.log("There was an error:", error.response); // Logs out the error
              this.isLoading = false;
            });
      },
      getListPeran(){
        console.log("get all peran")
        apiServer
          .get("/peran/all")
          .then(response => {
            console.log(response.data.data)
            this.allperans = response.data.data
            console.log(this.allperans)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      cancel() {
        this.$router.push('/pengguna')
      }
    }
  }
</script>
  